{
  "materialEmissions": [
    {
      "label": "Productie",
      "code": "Ap",
      "value": 4805,
      "iconPath": "assets/img/me_productie_Ap.svg",
      "iconMessage": "De productiefase omvat de modules A1, A2 en A3, die gezamenlijk als module A1-A3 behandeld worden. Het gaat om de winning-, transport en (half)productie van de producten en/of processen, zoals die toegepast gaan worden bij de realisatie van het bouwwerk."
    },
    {
      "label": "Constructie",
      "code": "Ac",
      "value": 1010,
      "iconPath": "assets/img/me_constructie_Ac.svg",
      "iconMessage": "De bouwfase omvat de modules A4 en A5. Module A4 betreft het transport van de producten naar de bouwplaats. Module A5 betreft het aanbrengen van de producten en toepassing van processen bij de realisatie van bouwwerk, inclusief het daarbij ontstane bouwverlies."
    },
    {
      "label": "Gebruik",
      "code": "B",
      "value": 2100,
      "iconPath": "assets/img/me_gebruik_B.svg",
      "iconMessage": "De gebruiksfase omvat de modules B1-B5. In module B1 gaat het om de (continue) emissies, die in de gebruiksfase van het initiële product plaats vinden. De emissies van de vervangende producten worden aan Module B4 toegerekend. Module B2 betreft het onderhoud aan de producten, waarbij het net als bij B1 alleen gaat om de initiële producten. Module B3 betreft de reparatie aan de producten, waarbij het net als bij B1 alleen gaat om de initiële producten. Module B4 gaat om de vervanging van productonderdelen (milieuprofielen) bij de initiële producten én om de daaropvolgende vervangingen van producten tijdens de levensduur van het bouwwerk. Module B5 betreft de renovatie-ingrepen. In praktijk is er op het moment van nieuwbouw geen voorspelling te maken van een eventuele renovatie. Er is dus geen zinvol scenario op te stellen. B5 is daarom niet geoperationaliseerd en wordt om die reden niet in de rekenregels meegenomen."
    },
    {
      "label": "Afdank",
      "code": "C",
      "value": 874,
      "iconPath": "assets/img/me_afdank_C.svg",
      "iconMessage": "De afdankfase omvat module C1-C4. Module C1 betreft de verwijdering van de producten, waarbij het alleen gaat om de bij de sloop van het bouwwerk aanwezige producten. De impact gerelateerd aan de verwijdering van producten bij de vervangingen tijdens de gebruiksperiode wordt aan Module B4 toegerekend. Module C2 betreft de afvoer van de verwijderde producten naar de verwerkingslocaties. Net als bij module C1 gaat het alleen om de bij de sloop van het bouwwerk aanwezige producten. Module C3 betreft de verwerking van de verwijderde producten. Per product is er een andere verdeling mogelijk over de verschillende verwerkingsmogelijkheden. Net als bij module C1 gaat het alleen om de bij de sloop van het bouwwerk aanwezige producten. Module C4 betreft de finale afvalverwerking (stort) van de verwijderde producten. Net als bij module C1 gaat het alleen om de bij de sloop van het bouwwerk aanwezige producten."
    },
    {
      "label": "Buiten gebouwlevensloop",
      "code": "D1",
      "value": -1500,
      "iconPath": "assets/img/me_D1.svg",
      "iconMessage": "Module D1 op bouwwerkniveau worden de milieulasten en -baten meegenomen, die ontstaan vanuit de laatste productcyclus en alle vervangingen in module B4."
    }
  ],
  "operationEmissions": [
    {
      "label": "Operationeel energiegebruik",
      "code": "B6",
      "value": 7200,
      "iconPath": "assets/img/oe_op_energy_B6.svg",
      "iconMessage": "Module B6 betreft het operationele energiegebruik bij het gebruik van het bouwwerk. Voor de WLC-GWP wordt alleen module B6.1 meegenomen: ‘gebouwgebonden gereguleerd energiegebruik’. Module B6.2 ‘gebouwgebonden niet-gereguleerd energiegebruik’ en B6.3 ‘niet-gebouwgebonden energiegebruik’ zijn geen onderdeel van de rekenregels."
    },
    {
      "label": "Buiten systeem (geëxporteerde energie)",
      "code": "D2",
      "value": -1010,
      "iconPath": "assets/img/oe_builten_syst_D2.svg",
      "iconMessage": "Voor geëxporteerde energie gelden substitutiebaten in module D2, gelijk aan de gemiddelde energiemix van de energiedrager. Dit betekent, wanneer energie uit PV wordt geëxporteerd dat dit de gemiddelde netmix substitueert in module D2. Het is mogelijk dat niet alle geëxporteerde energie kan worden opgenomen door de energieleverancier, in dat geval gaat de energie ‘verloren’. Voor de WLC-GWP wordt er hiervoor vooralsnog geen correctie op gemaakt."
    }
  ]
}
